export enum UranaishiOptions {
  FirstDayShiroUranaiOn = "FirstDayShiroUranaiOn",
  FirstDayUranaiOff = "firstDayUranaiOff",
}

export enum KaryudoOptions {
  RenzokuGoeiOn = "RenzokuGoeiOn",
  RenzokuGoeiOff = "RenzokuGoeiOff",
}

export const KaryudoOptionDefault = KaryudoOptions.RenzokuGoeiOff;
